import React, { Suspense } from 'react';
import ReactDom from 'react-dom';
import dynamic from 'next/dynamic';

import datadogRumClient from '../utils/datadog-rum';

if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
  // eslint-disable-next-line global-require
  const axe = require('react-axe');
  axe(React, ReactDom, 1000);
}

const RESET_PASSWORD_ROUTE_BASE = '/reset-password/:type';
const RESET_PASSWORD_ROUTE_PARAMS = '/:uid/:token';
export const RESET_PASSWORD_ROUTE = `${RESET_PASSWORD_ROUTE_BASE}${RESET_PASSWORD_ROUTE_PARAMS}`;

class WebReg extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);

    // init datadogRUM
    datadogRumClient.start();
  }

  getAppComponent() {
    const AppComponent = dynamic(() => import('./AppComponent'));

    return <AppComponent {...this.props} />;
  }

  getModularReduxAppComponent() {
    const AppComponent = dynamic(() => import('./ModularAppComponent'));

    return <AppComponent {...this.props} />;
  }

  getAppComponentBasedOnModularReduxToggle() {
    if (this.props.featureToggles.modularReduxEnabled.enabled) {
      return this.getModularReduxAppComponent();
    }
    return this.getAppComponent();
  }

  render() {
    return (
      <Suspense fallback={`...Loading`}>
        {this.getAppComponentBasedOnModularReduxToggle()}
      </Suspense>
    );
  }
}

export default dynamic(async () => WebReg, { ssr: false });
